import { CanActivateFn, Router } from "@angular/router";
import { DualAuthService } from "../services/DualAuthService";
import { inject } from "@angular/core";

export const adminGuard: CanActivateFn = (route, state) => {
    const auth = inject(DualAuthService);
    const router = inject(Router);
    if (auth.isEmployee() && auth.currentUser$.subscribe(user => user?.roles && 
        (user.roles.includes('Administrator')))) {
        return true;
    }
    try {
        auth.loginEmployeeRedirect();
    } catch {
        // If redirect fails for some reason, navigate to employee login route
        router.navigate(['login/employee']);
    }
    return false;
};